import React from 'react'
const initialState = {
  data: [],
  campaign_id: '',
  error: false,
  isLoading: false,
  redirect: false,
  path: false,
}

const CreateTaskReducer = (state = initialState, action) => {
  let index = ''
  switch (action.type) {
    case 'CREATE_TASK_ADDED':
      return {
        ...state,
        data: action.data,
        campaign_id: action.campaign_id,
        error: false,
        isLoading: false,
        redirect: false,
        path: false,
      }
    case 'CREATE_TASK_INIT':
      return {
        ...state,
        data: [],
        campaign_id: '',
        error: false,
        isLoading: false,
        redirect: false,
        path: false,
      }
    case 'CREATE_TASK_ERROR':
      return {
        ...state,
        error: action.error,
      }

    case 'CREATE_TASK_REDIRECT':
      return {
        ...state,
        error: action.error,
        isLoading: action.isLoading,
      }
    default:
      return state
  }
}

export default CreateTaskReducer
